export default __webpack_public_path__ + "static/picAssociation-6347c1d706c3bcc56aa4b77446be8435.jpg";